/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const serviceworldHeroStyle = {
  serviceworldHero: (theme: Theme) => ({
    paddingTop: "1rem",
    background: theme.palette.gradients.glacial,
    [theme.breakpoints.up("md")]: {
      paddingTop: "3rem",
    },
  }),
  image: { display: "block", maxHeight: "647px", maxWidth: "100%", margin: "0 auto", paddingLeft: "1rem", paddingRight: "1rem", width: "auto", height: "auto" },
};
